import axios from 'axios'
import router from '@/router'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

const service = axios.create({
  baseURL: '/api',
  timeout: 15 * 10000 // 请求超时时间
})

service.interceptors.request.use((config) => {
  config.headers.token = localStorage.getItem('gasHomeToken')
  return config
}, (error) => {
  Promise.reject(error)
})

service.interceptors.response.use((response) => {
  if (response) {
    if (response.data && response.data[0] && (response.data[0].status == 2002
        || response.data[0].status == 2003)) {
      setTimeout(function(){
        //  控制路由跳转或者直接改变href到登录页
        localStorage.removeItem('gasHomeToken')
        window.location.href = '/';
      },1000)
    } else {
      return response.data
    }
  }
}, (error) => {
  return Promise.reject(error)
})

export default service